// frontend/src/pages/NotFound.js
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';

const GOLD = '#B8842E';
const NAVY = '#1c1c1e';

function NotFound() {
  return (
    <div>
      <Header />

      <div style={{ background: '#F4F5F7', padding: '80px 16px' }}>
        <div
          style={{
            maxWidth: 560,
            margin: '0 auto',
            background: '#FCFCFA',
            borderRadius: 18,
            padding: '56px 36px',
            textAlign: 'center',
            boxShadow: '0 10px 40px rgba(0,0,0,.06)',
          }}
        >
          <div
            style={{
              fontFamily: 'Georgia, serif',
              fontWeight: 700,
              fontSize: 88,
              lineHeight: 1,
              color: GOLD,
              marginBottom: 8,
            }}
          >
            404
          </div>

          <h1 style={{ color: NAVY, fontWeight: 800, fontSize: 26, marginBottom: 10 }}>
            Page Not Found
          </h1>

          <p style={{ color: '#6b6f76', fontSize: 15.5, lineHeight: 1.6, maxWidth: 400, margin: '0 auto 30px' }}>
            The page you're looking for doesn't exist, may have been moved, or the link might be broken.
          </p>

          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link
              to="/"
              style={{
                display: 'inline-block',
                background: GOLD,
                color: '#fff',
                fontWeight: 700,
                fontSize: 14,
                textDecoration: 'none',
                padding: '13px 30px',
                borderRadius: 999,
              }}
            >
              <i className="bi bi-house-door-fill me-2"></i>Back to Home
            </Link>

            <Link
              to="/BuyBook"
              style={{
                display: 'inline-block',
                background: 'transparent',
                color: NAVY,
                fontWeight: 700,
                fontSize: 14,
                textDecoration: 'none',
                padding: '12px 28px',
                borderRadius: 999,
                border: `1.5px solid ${NAVY}`,
              }}
            >
              Get the Book
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default NotFound;
